export const cropSentence = (
  sentence: string | undefined | null,
  maxLength: number = 30
): string => {
  if (!sentence) {
    return "";
  }
  if (sentence.length <= maxLength) {
    return sentence;
  }
  return sentence.substring(0, maxLength - 3) + "...";
};
